import React from "react"
import "./Home.css"
import hero from "../pic/hero.jpg"
import { Typewriter } from "react-simple-typewriter"
import {ImLinkedin} from "react-icons/im"
import {FaGithubSquare} from "react-icons/fa"
const Home = () => {
  return (
    <>
      <section className='hero' id='home'>
        <div className='container f_flex top'>
          <div className='left top'>
            <h3>WELCOME TO MY WORLD</h3>
            <h1>
              Hi, I’m <span>Niranjan</span>
            </h1>
            <h2>
              a 
              <span>
                <Typewriter words={["  Professional Coder.", " MERN Stack Developer."]} loop cursor cursorStyle='|' typeSpeed={70} deleteSpeed={50} delaySpeed={1000} />
              </span>
            </h2>

            <p>with an ability to develop websites that are both functional and aesthetically pleasing. I have a good understanding of web standards and best practices, and I am passionate about creating websites that users will find easy to use and visually appealing. and ready to contribute to any project.</p>
            <div className='hero_btn d_flex'>
              <div className='col_1'>
                <h4>FIND ME HERE</h4>
                <div className='button'>
                  <a href="https://www.linkedin.com/in/niranjan-salunkhe/"  target="_blank" rel="noopener noreferrer">
                  <button className='btn_shadow'>   
                  <ImLinkedin fontSize={30}/>
                  </button>
                  </a>
                  <a href="https://github.com/nsalunkhe"  target="_blank" rel="noopener noreferrer">
                  <button className='btn_shadow'>
                    <FaGithubSquare fontSize={30}/>
                  </button>
                  </a>
                </div>
              </div>
              {/* <div className='col_1'>
                <h4>BEST SKILL ON</h4>
                <button className='btn_shadow'>
                  <img src={skill1} alt='' />
                </button>
                <button className='btn_shadow'>
                  <img src={skill2} alt='' />
                </button>
                <button className='btn_shadow'>
                  <img src={skill3} alt='' />
                </button>
              </div> */}
            </div>
          </div>
          <div className='right'>
            <div className='right_img'>
              <img src={hero} alt=''  />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Home